import { desktop } from '@hg/stylizator/utils'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled, { css } from 'styled-components'

import { tocStripMobileOptions } from 'app/components/blog/TableOfContents'

const BlogHeadingBlock: React.FC<IWPGBlock> = (props) => (
  <Spacing clearfix={props.innerHTML.includes('ez-toc-container')}>
    {parse(props.innerHTML, tocStripMobileOptions)}
  </Spacing>
)

export default BlogHeadingBlock

const Spacing = styled.div<{ clearfix?: boolean }>`
  width: 100%;
  margin-top: 40px;

  h2 {
    font-size: 21px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  h6 {
    font-size: 12px;
  }

  @media ${desktop} {
    margin-top: 56px;
  }

  ${(props) =>
    props.clearfix &&
    css`
      &:before,
      &:after {
        display: block;
        clear: both;
        content: '\a0 ';
        visibility: hidden;
        height: 0;
      }
    `}
`
